var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "LoadingPlan" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Code",
                        error: _vm.$v.form.Code,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "LoadingDate",
                        error: _vm.$v.form.LoadingDate,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.LoadingDate },
                        model: {
                          value: _vm.form.LoadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoadingDate", $$v)
                          },
                          expression: "form.LoadingDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "RouteId",
                        error: _vm.$v.form.RouteId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url: "VisionNextRoute/api/Route/Search",
                          "dynamic-and-condition": {
                            RouteTypeIds: [1],
                            StatusIds: [1]
                          },
                          "order-by-columns": [
                            { Column: "Description1", OrderByType: 0 }
                          ],
                          "page-count": 500
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("RouteId", $event)
                          }
                        },
                        model: {
                          value: _vm.selectedRoute,
                          callback: function($$v) {
                            _vm.selectedRoute = $$v
                          },
                          expression: "selectedRoute"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.loadingplan.items"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.loadingplan.items"),
                            error: _vm.$v.detailPanel.item,
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextItem/api/Item/AutoCompleteSearch",
                              searchable: "",
                              "or-condition-fields": "Code,Description1",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                CardTypeIds: [1, 2, 8]
                              },
                              "custom-option": ""
                            },
                            model: {
                              value: _vm.detailPanel.item,
                              callback: function($$v) {
                                _vm.$set(_vm.detailPanel, "item", $$v)
                              },
                              expression: "detailPanel.item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.loadingplan.PlanQuantity"),
                            error: _vm.$v.detailPanel.planQuantity,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", min: "1" },
                            on: {
                              keypress: function($event) {
                                return _vm.onlyForCurrencyDot($event)
                              }
                            },
                            model: {
                              value: _vm.detailPanel.planQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.detailPanel, "planQuantity", $$v)
                              },
                              expression: "detailPanel.planQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "ml-auto",
                          attrs: { cols: "12", md: "1" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItems($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c("NextMultipleSelection", {
                            attrs: {
                              name: "LoadingPlanMultipleItem ",
                              "hidden-values": _vm.hiddenValues,
                              "filter-func": function(row) {
                                return row.PlanQuantity > 0
                              },
                              validations: _vm.multipleValidations
                            },
                            model: {
                              value: _vm.form.LoadingPlanItems,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LoadingPlanItems", $$v)
                              },
                              expression: "form.LoadingPlanItems"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _vm.form.LoadingPlanItems &&
                          _vm.form.LoadingPlanItems.length > 0
                            ? _c("NextExportDetail", {
                                attrs: {
                                  url:
                                    "VisionNextStockManagement/api/LoadingPlan/ExcelExportItems",
                                  "record-id": _vm.form.RecordId,
                                  "record-key": "loadingPlanId",
                                  "file-name": _vm.$t(
                                    "insert.loadingplan.items"
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.loadingplan.items")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.loadingplan.PlanQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.form.LoadingPlanItems
                                    ? _vm.form.LoadingPlanItems.filter(function(
                                        l
                                      ) {
                                        return l.RecordState !== 4
                                      })
                                    : [],
                                  function(r, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              r.Item
                                                ? r.Item.Label
                                                : r.Description1
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.PlanQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-edit text-warning",
                                              on: {
                                                click: function($event) {
                                                  return _vm.editItems(r)
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "far fa-trash-alt text-danger",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeItems(r)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bd28092", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bd28092","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoadingPlan/update.vue
// module id = null
// module chunks = 